import { getFieldGroupForTab } from 'ContentComponents/components/cmv2/utils';
import { CONTENT, STYLE } from 'ContentUtils/constants/CustomWidgetFieldGroupTabTypes';
import { getModuleType } from 'EmailData/constants/DefaultModulesConstants';
/**
 * @temporary @dkeogh - Remove when all of the default DND email modules are migrated to use style fields
 * @expiration 2026-03-31
 * @deprecated
 */
export const DEFAULT_MODULE_STYLE_FIELD_MIGRATION_CONFIG = {
  BUTTON: {
    migrateAll: false,
    fieldNames: ['alignment', 'background_color', 'border_color', 'border_enabled', 'border_width', 'corner_radius', 'font_style', 'make_full_width', 'inner_vertical_padding', 'inner_horizontal_padding']
  },
  DIVIDER: {
    migrateAll: true
  },
  EMAIL_ABANDONED_CART: {
    migrateAll: false,
    fieldNames: ['button_styles', 'divider_styles', 'font_styles', 'image_style']
  },
  EMAIL_CART: {
    migrateAll: false,
    fieldNames: ['button_styles', 'divider_styles', 'font_styles', 'image_style']
  },
  EMAIL_PRODUCTS: {
    migrateAll: false,
    fieldNames: ['button_styles', 'divider_styles', 'font_styles', 'image_style']
  },
  EMAIL_VIDEO: {
    migrateAll: false,
    fieldNames: ['alignment', 'style_options']
  },
  FOOTER: {
    migrateAll: false,
    fieldNames: ['align', 'font', 'link_font']
  },
  IMAGE: {
    migrateAll: false,
    fieldNames: ['alignment', 'corner_radius', 'corner_radius_unit']
  },
  WEB_VERSION_LINK: {
    migrateAll: false,
    fieldNames: ['align', 'font']
  }
};

/**
 * @temporary @dkeogh - Remove when all of the default DND email modules are migrated to use style fields
 * @expiration 2026-03-31
 * @deprecated
 */
export const isDefaultModuleWithStyleField = moduleSpec => {
  const moduleType = getModuleType(moduleSpec.moduleId);
  const moduleTabConfig = DEFAULT_MODULE_STYLE_FIELD_MIGRATION_CONFIG[moduleType];
  if (moduleTabConfig && !moduleTabConfig.migrateAll && moduleTabConfig.fieldNames.length) {
    return true;
  }
};

/**
 * @temporary @dkeogh - Remove when all of the default DND email modules are migrated to use style fields
 * @expiration 2026-03-31
 * @deprecated
 */
export function withModuleTabMigrationFilter({
  isDefaultModule,
  moduleSpec,
  tab
}) {
  const hasStyleFields = Array.isArray(moduleSpec.fields) && Boolean(getFieldGroupForTab(moduleSpec.fields, STYLE));
  if (hasStyleFields || !isDefaultModule) {
    return moduleSpec;
  }
  const moduleType = getModuleType(moduleSpec.moduleId);
  const moduleTabConfig = DEFAULT_MODULE_STYLE_FIELD_MIGRATION_CONFIG[moduleType];
  if (!moduleTabConfig) {
    if (tab === STYLE) {
      return Object.assign({}, moduleSpec, {
        // This default module does not have a `STYLE` tab, we'll return an empty fields list
        // to avoid displaying any `CONTENT` fields inside of the "fake" styles tab
        fields: []
      });
    }
    return moduleSpec;
  }

  // *All* of this module's fields are marked to be moved to the `STYLE` tab, so the content
  // tab will be empty, and we'll print everything on the "fake" styles tab.
  if (moduleTabConfig.migrateAll) {
    if (tab === STYLE) {
      return moduleSpec;
    }
    return Object.assign({}, moduleSpec, {
      fields: []
    });
  }
  return Object.assign({}, moduleSpec, {
    fields: moduleSpec.fields.map(field => {
      const isVisibleOnStyleTabOnly = moduleTabConfig.fieldNames.includes(field.name);
      if (tab === CONTENT && isVisibleOnStyleTabOnly || tab === STYLE && !isVisibleOnStyleTabOnly) {
        return Object.assign({}, field, {
          locked: true
        });
      }
      return field;
    })
  });
}

/**
 * @temporary @dkeogh - Remove when all of the default DND email modules are migrated to use style fields
 * @expiration 2026-03-31
 * @deprecated
 */
export function maybePrependStyleGroup(moduleSpec, fieldName, styleFieldName) {
  if (!getFieldGroupForTab(moduleSpec.fields, STYLE)) {
    return fieldName;
  }
  if (styleFieldName) {
    return styleFieldName;
  }
  const modifiedFieldName = ['style'];
  if (Array.isArray(fieldName)) {
    modifiedFieldName.push(...fieldName);
  } else {
    modifiedFieldName.push(fieldName);
  }
  return modifiedFieldName;
}